import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AlertService, AuthenticationService, GlobalService, ShadowService } from 'src/app/shared/_services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss']
})
export class ForgotPasswordPage implements OnInit {
  passwordResetForm: FormGroup;
  loading = false;
  queryParams: string;

  constructor(
    private alertService: AlertService, private shadowService: ShadowService, private formBuilder: FormBuilder,
    private auth: AuthenticationService, private router: Router, private globalService: GlobalService,
    private platform: Platform
  ) { }

  get email() {
    return this.passwordResetForm.get('email');
  }
  public errorMessage = {
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'pattern', message: 'Please enter a valid email' }
    ]
  };

  resetPassword() {
    if (this.passwordResetForm.invalid) {
      return;
    }
    this.loading = true;
    this.auth.forgotPassword(this.email.value)
    .subscribe(
      response => {
        this.loading = false;
        console.log(response);
        this.alertService.callToAction(
          'Successful!',
          'Please follow the link sent to your email to reset your password',
          this.platform.is('cordova') ? 'Open Email' : 'Go back'
        );
      },
      error => {
        this.loading = false;
        console.log(error);
        if (error.error.message.includes('There is no user with email address')) {
          this.alertService.retry('Your email address is not registered on Bank3D', null, true);
        } else if (error.status === 0 || error.statusText.includes('Unknown Error')) {
          this.alertService.loadingNullDuration(this.globalService.errorText.oops +
          this.globalService.errorText.persists);
        }
      }
    );
  }

  goBack() {
    this.router.navigateByUrl('/login');
  }

  ionViewWillEnter() {
    document.title = 'Forgot Password | Bank3D';
    this.shadowService.button();
  }

  ngOnInit() {
    this.queryParams = window.location.search;
    this.passwordResetForm = this.formBuilder.group({
      email: ['', [ Validators.required, Validators.pattern('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')]]
    });
    window.onpopstate = (() => {
      this.alertService.checkForAlert();
    });
    window.addEventListener('keydown', (e) => {
      const pathname = window.location.pathname;
      if (e.key === 'Enter' && this.passwordResetForm.valid && pathname.includes('forgot')) {
        e.preventDefault();
        this.resetPassword();
      }
    });
  }
}
